import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';


@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.css']
})
export class HomeNewComponent implements OnInit {
  subscription: Subscription;
  data: {};
  error: string;
  name: string;
  email: string;
  mobile: string;
  prospectId: string;
  prospectIdFHI: string;
  prospectIdPA: string;
  prospectIdMotor: string;
  prospectIdPI: string;
  prospectIdCovid: string;
  prospectIdWellness: string;
  partnerId: string;
  claimsRegisterModal: boolean = true;
  userDetails: object = {} ;
  loading :boolean;
  notificationCounter: string;
  notificationCount: boolean;
  private onDestroy$: Subject<void> = new Subject<void>();
  //for disabling div  in production
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) { 
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
  }

  ngOnInit() {
    var hostname = window.location.hostname;
    if( hostname == "staging.securenow.app"  || hostname == "localhost"){
      this.partnerId = "997";
    }
    else if(hostname == "securenow.app"){
      this.partnerId = "997";
    }
    // this.getNotificationCount();
    // const source = interval(15000);
    // this.subscription = source.subscribe(val => this.getNotificationCount());
    
  }
  createProspectForFHI(){

    this.data = {
      mobile: this.mobile,
      prospectId : "",
      rmId : "",
      product : 95,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel : "Notify-App",
      leadSource : "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    var prospectIdFHI = localStorage.getItem('prospectIdFHI');
    if(!prospectIdFHI){
      this.serviceURLService.saveFHIProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        // console.log("Prospect created successfully ",successData)
          this.prospectIdFHI = successData.data.prospectId;
          localStorage.setItem("prospectIdFHI", this.prospectIdFHI)
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
  }
  
  createProspectForMotor(){
    this.data = {
      mobile: this.mobile,
      prospectId : "",
      rmId : "",
      product : 23,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    this.getProductId();
    var prospectIdMotor = localStorage.getItem('prospectIdMotor');
    if(!prospectIdMotor){
      this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        // console.log("Prospect created successfully ",successData)
          this.prospectIdMotor = successData.data.prospectId;
          localStorage.setItem("prospectIdMotor", this.prospectIdMotor)
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
  }
  createProspectForPA(){

    this.data = {
      mobile: this.mobile,
      prospectId : "",
      rmId : "",
      product : 129,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    var prospectIdPA = localStorage.getItem('prospectIdPA');
    if(!prospectIdPA){
      this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        // console.log("Prospect created successfully ",successData)
          this.prospectIdPA = successData.data.prospectId;
          localStorage.setItem("prospectIdPA", this.prospectIdPA)
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
  }

  createProspectForPI(){

    this.data = {
      mobile: this.mobile,
      prospectId : "",
      rmId : "",
      product : 83,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    var prospectIdPI = localStorage.getItem('prospectIdPI');
    if(!prospectIdPI){
      this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
         console.log("Prospect created successfully ",successData)
          this.prospectIdPI = successData.data.prospectId;
          localStorage.setItem("prospectIdPI", this.prospectIdPI)
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
  }

  createProspectForWelness(){
    this.loading= true;
    this.data = {
      mobile: this.mobile,
      prospectId : "",
      rmId : "",
      product : 139,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    var prospectIdWellness = localStorage.getItem('prospectIdWellness');
    if(!prospectIdWellness){
      this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
         console.log("Prospect created successfully ",successData)
          this.prospectIdWellness = successData.data.prospectId;
          localStorage.setItem("prospectIdWellness", this.prospectIdWellness)
      }, errorData => {
        this.loading = false;
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
    this.healthAssureUpdate();
  }

  healthAssureUpdate(){
    this.loading = true;
    this.userDetails = {
      UserName:"pujasingh@securenow.in", // hardcode
      FirstName: this.name, //full name
      LastName:"", 
      Email: this.email, 
      Mobile: this.mobile,
      EmpNo:"", //blank
      DoB:"", //blank
      Gender:"", //blank
      AccessCode:"SN0001", // hardcode
      partnerId:"",
      product: 139,
      company:"",
      designation:"",
      channel:"",
      googleClickID:"",
      leadSource:"Notify-App",
      location:"",
      prospectId:"",
      rmId:""
    }

    let dataUser = {"userDetails":this.userDetails};

    
    this.serviceURLService.updateWellnessRegistration(dataUser).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        // console.log("Wellness regitration successfull ",successData)
        this.loading = true;
        var HALink = successData.response.HALink;
        window.location.href = HALink;
    }, errorData => {
      this.loading = false;
      console.log("Oops..!! there is some error in prospect creation");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  createProspectForCovid(){
    this.loading = true;
    this.data = {
      mobile: this.mobile,
      prospectId : "",
      quoteId : "",
      rmId : "",
      product : 140,
      email : this.email,
      name : this.name,
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : this.partnerId,
      channel : "Notify-App",
      leadSource : "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    var prospectIdCovid = localStorage.getItem('prospectIdCovid');
    if(!prospectIdCovid){
      this.serviceURLService.createProspectForCovid(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        this.loading = false;
          this.prospectIdCovid = successData.data.data.prospectId;
          localStorage.setItem("prospectIdCovid", this.prospectIdCovid);
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          this.error = errorData.error.message;
        }
      })
    }
  }

  getProductId(){
    this.serviceURLService.getProductId().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      // console.log("Product ID send successfully",successData)
      
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  registerNow(){
    this.router.navigate(['email']);
  }

  // getNotificationCount(){
  //   this.serviceURLService.getNotificationCount().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
  //     this.notificationCounter = successData.response
  //     if(this.notificationCounter > "0"){
  //       this.notificationCount = true;
  //     }
  //   }, errorData => {
  //     console.log("Oops..!! there is some error in prospect creation");
  //     if(errorData.error.status === 403){
  //       this.error = errorData.error.message;
  //     }
  //   })
  // }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}